<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div class="col-lg-3 aos-init aos-animate text-center d-none d-lg-block mx-auto resume-content" data-aos="fade-right fade-left" data-aos-delay="100" >
          <div class="card resume-content float-right">
            <div class="card-header"><div class="tarjeta-perfil"></div></div>
            <div class="card-body">
              <div class="card-text">
                <span>Nombre Empresa</span> <p class="text-truncate">{{client.nombreEmpresa}}</p>
              </div>
              <div class="card-text">
                <span>RUT empresa</span> <p>{{client.rutEmpresa}}-{{client.rutEmpresaDv}}</p>
              </div>
              <div class="card-text">
                <span>Correo Corporativo</span> <p class="text-truncate">{{client.email}}</p>
              </div>
              <div class="card-text">
                <span class="text-primary">Deuda Total</span> <h4 class="mt-1">{{totalDeuda|currency}}</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-9 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
          <h3>Realizar Abono</h3>
          
          <div class="card card-row d-flex flex-row mb-4">
            <div class="row d-flex flex-row mb-0 justify-items-between  align-items-start">
              
              <div class="col-12">
                <p>Puedes realizar un abono a tu cuenta libremente.
  El movimiento se verá reflejado inmediatamente en tu cuenta corriente.</p>
                <div class="d-flex justify-content-between align-items-start row">
                   <div class="form-group col-sm-12 col-lg-4 mb-1 mt-1">
                    <label for="inputRut">Monto del Abono</label>
                    <money v-model="$v.form.monto.$model" v-bind="money" 
                      id="example-input-1"
                      min=1 max=99999999
                      name="example-input-1"
                    :state="validateState('monto')"
                      aria-describedby="input-1-live-feedback" autofocus
                    class="form-control"></money>
                    <b-form-invalid-feedback id="input-1-live-feedback">
                      Monto es requerido y debe ser valido.
                    </b-form-invalid-feedback>
                  </div>
                  <div class="form-group col-sm-12 col-lg-4 mb-1 mt-1">
                    <label for="inputRut">Comentario</label>
                    <b-form-input
                      class="form-control"
                      id="example-input-2"
                      name="example-input-2"
                      v-model="$v.form.comentario.$model"
                      :state="validateState('comentario')"
                      aria-describedby="input-2-live-feedback" autofocus
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-2-live-feedback">
                      Comentario es requerido y debe ser valido.
                    </b-form-invalid-feedback>
                  </div>
                  <div class="form-group col-sm-12 col-lg-4 mb-1 mt-1 text-center">
                    <label for="inputMount" class="justify-content-center text-center">Fecha del Abono</label>  
                    <span id="inputMount" class="justify-content-center text-center mt-10"><h3>{{currentDate | formatDate}}</h3></span>
                  </div>
                  
                </div>
               
              </div>
            </div>

          </div>
          <br/>
          
          <h2>Medios de Pago</h2>
          
          <div class="card-row card-bancos row">
          <template v-for="(item, x) in methods">
            <div v-bind:key="x + '-pay'" >
              <selectable-plan
                :plan-codigo="item.codigo"
                v-model="codigoMedioPago"
              ></selectable-plan>
            </div>
          </template>
          </div>
           <form id="irapagar" name="irapagar" method="post" :action="order.payUrl">
              <input type="hidden" name="guidTransaccion" :value="order.guidTransaccion" />
              <input type="hidden" name="idEntidadRecaudadora" :value="order.idEntidad" />
              <input type="hidden" name="codigoAplicacion" :value="order.codigoAplicacion" />
              <input type="hidden" name="rutCliente" :value="rutCliente" />
              <input type="hidden" name="monto" :value="order.monto" />
            </form>
          <div class="row mt-2 mb-5 row-buttons">
            <a href="#" v-on:click.prevent="getOrder()" class="btn btn-primary mr-3">Pagar</a> 
            <button class="btn btn-outline-secondary" disabled>Cancelar</button>
          </div>
        </div>
      </div>
    <!--end::Dashboard-->
</template>


<script>

import { mapState } from "vuex";
import { GET_DOCUMENTS } from "@/core/services/store/client.module";
import { GET_METHODS, CREATE_CREDIT } from "@/core/services/store/payment.module";
import SelectablePlan from '@/view/content/widgets/payments/PaymentMethods.vue'
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {Money} from 'v-money'

import { validationMixin } from "vuelidate";
import { minLength, maxLength, required, between } from "vuelidate/lib/validators";

import moment from 'moment'
moment.locale( 'es' );

export default {
  mixins: [validationMixin],
  name: "credit",
  components: {Money, SelectablePlan},
  data() {
    return {
      form: {
        monto: "",
        comentario:""
      },
      currentDate : new Date(),
      sucursal:'',
      codigoMedioPago: '',
      order:{},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      }
    };
  },
  validations: {
    form: {
      monto: {
        required,
        
        between: between(10, 99999999)
       // rut
      },
      comentario: {
        required,
        minLength: minLength(3),
        maxLength:maxLength(100)
       // rut
      }
    }
  },
  mounted () {
    this.getDocuments();
    this.getMethods();
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        monto: null,
        comentario:null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },

    getDocuments() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_DOCUMENTS, this.$store.state.auth.user)
          .then(()=>{this.$Progress.finish()});
    },
    getMethods() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_METHODS)
          .then(()=>{this.$Progress.finish()});
    },
    getOrder() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const monto = this.$v.form.monto.$model;
      const comentario = this.$v.form.comentario.$model;
      const t = this;
      this.$store
          .dispatch(CREATE_CREDIT, {"codigoMedioPago":this.codigoMedioPago, "Detalles":null, "monto": monto, "observaciones":comentario})
          .then(function(response){
            t.order = response;
            setTimeout(function()
              {
                if(t.order.nuevaVentana){
                  var left = (screen.width/2)-(800/2);
                  var top = (screen.height/2)-(600/2);
                  window.open('', 'formpopup', 'width=800,height=600,resizeable,scrollbars, top='+top+', left='+left);
                  document.getElementById("irapagar").target = 'formpopup';
                }
                document.getElementById("irapagar").submit();
              }, 10);
          });
    },
    onUpdatePay(activePay){
      this.codigoMedioPago = activePay;
    }
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    ...mapState({
      documents : state => state.client.documents,
      sucursales : state => state.client.branchs,
      methods : state => state.payment.methods,
      errors: state => state.errors,
      client: state => state.auth.user,
      totalSumm: function(){
        return this.documents.filter(item => item.seleccionado).reduce(function(total, item){

          return total + (item.saldo); 
        },0);
      }, 
      totalDeuda: function(){
        return this.documents.reduce(function(total, item){

          return total + (item.monto - item.abonado); 
        },0);
      },
      rutCliente: function(){
        return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
      },  
    })
  }
};
</script>
<style>
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}
</style>
